import { Component } from '@angular/core';
import { NbSidebarService } from '@nebular/theme';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <!-- <nb-layout windowMode>
      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive start>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-header>
        <ngx-header></ngx-header>
      </nb-layout-header>
      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout> -->

    <nb-layout>
      <nb-layout-header subheader>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive start>
        <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
          <!-- <nb-icon icon="menu-2-outline"></nb-icon> -->
          <nb-icon icon="close-outline"></nb-icon>
        </a>
        <div class="sidebar__logo">
          <img src="../../../../assets/images/logo.png" alt="logo" />
        </div>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column class="colored-column-basic">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent {
  constructor(
    private sidebarService: NbSidebarService // private menuService: NbMenuService,
  ) {}

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    document.body.classList.toggle('sidebar-collapsed');
    const header = document.getElementsByTagName('nb-layout-header');
    header[0].classList.toggle('sidebar-collapsed');
    console.log('header', header);

    return false;
  }
}
